import { ComponentChildren } from 'preact';

export const PrivacyFooter = ({ children }: { children?: ComponentChildren }) => (
  <div id="fixedfooter" class="privacy-prompt-panel-footer">
    {children}
  </div>
);
